import React, { useState } from "react";
import DatePicker from "components/Common/DatePicker/datepicker";

const today = new Date();
const pad = (n) => String(n).padStart(2, "0");
const formattedToday = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

const FilterMarketingReport = ({ updateMultipleFilters }) => {
  const [date_from, setDateFrom] = useState(formattedToday);
  const [date_to, setDateTo] = useState(formattedToday);

  const handleSearch = () => {
    updateMultipleFilters({ date_from, date_to });
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ whiteSpace: "nowrap" }}>Date From:</label>
        <DatePicker
          name="date_from"
          value={date_from}
          onChange={(date) => setDateFrom(date)}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ whiteSpace: "nowrap" }}>Date To:</label>
        <DatePicker
          name="date_to"
          value={date_to}
          onChange={(date) => setDateTo(date)}
        />
      </div>

      <button className="btn btn-primary" onClick={handleSearch}>
        Search
      </button>
    </div>
  );
};

export default FilterMarketingReport;
